export enum IndomixTypeEnum {
    IndosinglA = 'IndosinglA',
    IndosinglPU50 = 'IndosinglPU50',
    IndosinglPU80 = 'IndosinglPU80',
    IndosinglEP = 'IndosinglEP',
    EmalIndopur = 'EmalIndopur',
}
